import { Client as Styletron } from 'styletron-engine-atomic';

// Style engine used by baseUI - unique, shared by react demos
// Add a prefix for the generated class names, to avoid collisions
// see https://www.styletron.org/api-reference#options
export const StyletronEngine = new Styletron({ prefix: 'c_'});
